import React from 'react';
import PropTypes from 'prop-types';

import { ListItem } from '../common/common';
import '../zones/zone-selector.css';

function InventoryItem({ inventory, onSelect }) {
    const onClick = React.useCallback(() => {
        onSelect(inventory);
    }, [inventory, onSelect]);

    return <ListItem onClick={onClick}>{inventory.name}</ListItem>;
}

InventoryItem.propTypes = {
    inventory: PropTypes.object.isRequired,
    onSelect: PropTypes.func.isRequired,
};

export function InventorySelector({ inventories, onChange }) {
    const inventoryItems = inventories.map((inventory) => (
        <InventoryItem
            key={inventory.uuid}
            onSelect={onChange}
            inventory={inventory}
        />
    ));

    return (
        <div className="throne-inventory-list-container">
            <div className="throne-list">{inventoryItems}</div>
        </div>
    );
}

InventorySelector.propTypes = {
    inventories: PropTypes.arrayOf(PropTypes.object).isRequired,
    onChange: PropTypes.func.isRequired,
};
